import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://redux-todo-by-tahmid.herokuapp.com",
  }),
  endpoints: (builder) => ({
    getTodos: builder.query({
      query: () => "/todos",
      providesTags: ["Todos"],
    }),
    addTodo: builder.mutation({
      query: (data) => ({
        url: "/todos",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Todos"],
    }),
    completeAllTodos: builder.mutation({
      query: (data) => ({
        url: `/todos/${data?.id}`,
        method: "PATCH",
        body: { ...data, completed: true },
      }),
      invalidatesTags: ["Todos"],
    }),
    clearCompleteTodos: builder.mutation({
      query: (data) => ({
        url: `/todos/${data?.id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Todos"],
    }),
    completeSingleTodo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body: { ...data, completed: !data?.completed },
      }),
      invalidatesTags: ["Todos"],
    }),
    updateColor: builder.mutation({
      query: ({ id, data, color }) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body: { ...data, color: color },
      }),
      invalidatesTags: ["Todos"],
    }),
    updateTitle: builder.mutation({
      query: ({ id, data, title}) => ({
        url: `/todos/${id}`,
        method: "PATCH",
        body: { ...data, text: title },
      }),
      invalidatesTags: ["Todos"],
    }),
    deleteTodo: builder.mutation({
      query: (id) => ({
        url: `/todos/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Todos"],
    }),
  }),
});

export const {
  useGetTodosQuery,
  useAddTodoMutation,
  useCompleteAllTodosMutation,
  useClearCompleteTodosMutation,
  useCompleteSingleTodoMutation,
  useUpdateColorMutation,
  useDeleteTodoMutation,
  useUpdateTitleMutation,
  useGetColoredTodosQuery
} = apiSlice;
